import React, { useState, useEffect } from "react";
import { getApiUrl, BASE_URL } from "../utils/api";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const AdvertisementBanner = () => {
  const UserId = "66abc123def4567890abcd12";

  const [banners, setBanners] = useState([]);
  const [selectedImages, setSelectedImages] = useState([]);
  const [loading, setLoading] = useState(false);

  /* ---------------- FETCH BANNERS ---------------- */
  const fetchBanners = async () => {
    try {
      const res = await fetch(getApiUrl("advertisementbanner-list"), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
      });

      const result = await res.json();

      if (result.success) {
        setBanners(result.data || []);
      }
    } catch (err) {
      toast.error("Failed to load advertisement banners");
    }
  };

  useEffect(() => {
    fetchBanners();
  }, []);

  /* ---------------- ADD MULTIPLE BANNERS ---------------- */
  const handleUpload = async () => {
    if (!selectedImages.length)
      return toast.error("Select at least one image");

    const formData = new FormData();
    formData.append("userid", UserId);

    selectedImages.forEach((img) => {
      formData.append("banners", img);
    });

    setLoading(true);
    const res = await fetch(getApiUrl("advertisementbanner-add"), {
      method: "POST",
      body: formData,
    });

    const result = await res.json();
    setLoading(false);

    if (result.success) {
      toast.success("Advertisement banners uploaded successfully");
      setSelectedImages([]);
      fetchBanners();
    } else {
      toast.error(result.message || "Upload failed");
    }
  };

  /* ---------------- DELETE SINGLE BANNER ---------------- */
  const handleDelete = async (index) => {
    const res = await fetch(getApiUrl("advertisementbanner-delete"), {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        userid: UserId,
        index,
      }),
    });

    const result = await res.json();

    if (result.success) {
      toast.success("Banner deleted");
      fetchBanners();
    } else {
      toast.error("Delete failed");
    }
  };

  /* ---------------- REPLACE SINGLE BANNER ---------------- */
  const handleReplace = async (index, file) => {
    const formData = new FormData();
    formData.append("userid", UserId);
    formData.append("index", index);
    formData.append("banner", file);

    const res = await fetch(getApiUrl("advertisementbanner-update"), {
      method: "POST",
      body: formData,
    });

    const result = await res.json();

    if (result.success) {
      toast.success("Banner updated");
      fetchBanners();
    } else {
      toast.error("Update failed");
    }
  };

  return (
    <div className="container mt-4">
      <ToastContainer position="top-right" autoClose={4000} />

      {/* HEADER */}
      <div className="d-flex justify-content-between mb-3">
        <h3 className="fw-bold">Advertisement Banner Management</h3>
      </div>

      {/* UPLOAD BOX */}
      <div className="card shadow-sm mb-4">
        <div className="card-body">
          <h5 className="fw-bold mb-3">Upload New Advertisement Banners</h5>

          <input
            type="file"
            multiple
            className="form-control mb-3"
            onChange={(e) => setSelectedImages([...e.target.files])}
          />

          {selectedImages.length > 0 && (
            <div className="d-flex flex-wrap gap-2 mb-3">
              {selectedImages.map((img, i) => (
                <img
                  key={i}
                  src={URL.createObjectURL(img)}
                  alt="preview"
                  width="100"
                  height="60"
                  className="rounded border"
                />
              ))}
            </div>
          )}

          <button
            className="btn btn-success"
            disabled={loading}
            onClick={handleUpload}
          >
            {loading ? "Uploading..." : "Upload Banners"}
          </button>
        </div>
      </div>

   
      <div className="card shadow-sm">
        <div className="card-body">
          <h5 className="fw-bold mb-3">Active Advertisement Banners</h5>

          {banners.length === 0 && (
            <p className="text-muted">No banners uploaded yet</p>
          )}

          <div className="row">
            {banners.map((banner, index) => (
              <div key={index} className="col-md-3 mb-4">
                <div className="border rounded p-2 text-center">
                  <img
                    src={`${BASE_URL}${banner}`}
                    alt="banner"
                    className="img-fluid rounded mb-2"
                    style={{ height: "120px", objectFit: "cover" }}
                  />

                  <div className="d-flex justify-content-between">
                    <label className="btn btn-sm btn-warning mb-0">
                      Replace
                      <input
                        type="file"
                        hidden
                        onChange={(e) =>
                          handleReplace(index, e.target.files[0])
                        }
                      />
                    </label>

                    <button
                      className="btn btn-sm btn-danger"
                      onClick={() => handleDelete(index)}
                    >
                      Delete
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdvertisementBanner;
